import PropTypes                   from 'prop-types';
import React                       from 'react';
import Flux                        from '../../../flux/Flux';
import Feed                        from '../../Feed/Feed';
import Translations                from '../../../utils/Translations';
import { getCommonTranslation}     from '../../../utils/TranslationHelper';
import {VXButtonLineConfig}        from "../../SimpleElements/VXButton/VXButtonConfig";
import ActorProfileHeatMap         from "./ActorProfileHeatMap";
import ActorMapContainer           from '../../ActorMap/ActorMapContainer.js';
import {COLOR_TYPE_CALL_TO_ACTION} from "../../SimpleElements/VXButton/ButtonHelper";
import {VXPay}                     from '../../../utils/VXPay';
import VXButton                    from "../../SimpleElements/VXButton/VXButton";
import ActorProfileFeedLike        from './ActorProfileFeedLike';

class ActorProfileFeed extends React.PureComponent {
  constructor(props) {
		super(props);

		this.state = {
			actorData:  this.props.actorData
		};

		this.onActorDataChange = this.onActorDataChange.bind(this);
		this.getSidebarContent = this.getSidebarContent.bind(this);
		this.getTopDistance    = this.getTopDistance.bind(this);
		this.setMapRef         = this.setMapRef.bind(this);
	}

  componentDidMount() {
		Flux.Actor.addActorDataChangeListener(this.onActorDataChange);
    if (!this.props.actorData) {
      Flux.Actor.loadActorData(this.props.actorId);
    }
	}

    componentDidUpdate() {
        if (this.state.mapRef) {
            setTimeout(() => {
                    this.state.mapRef.invalidateSize();
            }, 500); // Kurze Verzögerung für Layout-Updates
        }
    }

    componentWillUnmount() {
		Flux.Actor.removeActorDataChangeListener(this.onActorDataChange);
	}

    onActorDataChange() {
		const actorData = Flux.Actor.getActorData(this.props.actorId);

		if (actorData) {
			this.setState({actorData});
		}
	}

    setMapRef(ref) {
        if (ref) {
            this.setState({mapRef: ref});
        }
    }

  getSidebarContent(totalPostCount) {
    const actor = this.state.actorData;
    const isLoggedIn = Flux.Guest.isLoggedIn();

    const markers = [
      {'type': 'ImageMarker', actorId: this.props.actorId, position: actor.geoLocation, imagePath: actor.previewPicture, noPopup: true},
    ];

    if (actor.distance !== false) {
      let text = Translations.get('DistanceTo');
      if (text) {
        text = text.replace(':distance', '<span class="h-color-text-dark">' + Math.floor(actor.distance) + 'km</span>');
      }

      markers.push(
        {'type': 'TextMarker', actorId: this.props.actorId, position: actor.geoLocation, text: text}
      );
    }

    return <React.Fragment>
      <section className='feed__sidebar-block'>
        <h2 className='feed__headline'>{Translations.get('ActorHeaderNaviAboutMe')}</h2>
        <div className='feed__subline'><b>{totalPostCount}</b> {getCommonTranslation('contributions')} <b>{actor.favoriteCount || '0'}</b> { actor.favoriteCount && actor.favoriteCount !== 0 ? getCommonTranslation('followers') : getCommonTranslation('follower')}</div>
        {actor.freeText && <div className={'profile-feed__text'} dangerouslySetInnerHTML={{__html: actor.freeText}}></div>}
        {isLoggedIn && <ActorProfileFeedLike actorId={actor.id} actorName={actor.name} isFavorite={actor.isFavorite}/>}
      </section>

      {actor.isHeatmapActive && <div className='feed__sidebar-block'>
        <div className='profile-feed__heat-map'>
          <ActorProfileHeatMap
                actorId={this.props.actorId}
                actorIsOnline={actor.isOnline}
                actorLastOnline={actor.lastOnline}
                isLoggedIn={isLoggedIn}
                isMobile={true}
              />
        </div>
      </div>}

      {actor.geoLocation.length === 2 && <section className='feed__sidebar-block'>
        {isLoggedIn ? <div className='profile-feed__map'>
          <div className='feed__headline h-mb-20'>{Translations.get('ActorProfileHomeTitle')}</div>
          <ActorMapContainer
            avoidDuplicates={false}
            keepCenterOnZoom={true}
            className={"actor-map"}
            center={actor.geoLocation}
            dragging={false}
            touchZoom={false}
            boxZoom={false}
            tap={false}
            keyboard={false}
            scrollWheelZoom={false}
            zoom={11}
            minZoom={6}
            disableMapDragging={true}
            zoomControl={true}
            attributionControl={false}
            markers={markers}
            onCreated={this.setMapRef}
          />
        </div> : <div className=''>
          <div className='feed__subline feed__subline--condensed h-mb-30'>{getCommonTranslation('missing-actor-map-info', actor.name)}</div>
            <VXButton line1={[new VXButtonLineConfig(Translations.get('SignupForFree').toLocaleUpperCase())]}
                color={COLOR_TYPE_CALL_TO_ACTION}
                onClick={VXPay.openLogin}
            />
          </div>}
        </section>}
    </React.Fragment>;
  }

  getTopDistance() {
    if (this.props.isMobile) {
      const vxHeaderElem      = document.querySelector('.vxheader');
      const profileHeaderElem = document.querySelector('.actor-pictures__header-container.actor-pictures__header-container--top');
      const secondNavbarElem  = document.querySelector('.vxsecondnavbar__fixed');
      const vxHeader          = vxHeaderElem ? vxHeaderElem.getBoundingClientRect().height : 0;
      const profileHeader     = profileHeaderElem ? profileHeaderElem.getBoundingClientRect().height : 0;
      const secondNavbar      = secondNavbarElem ? secondNavbarElem.getBoundingClientRect().height : 0;
      return (vxHeader ? vxHeader : profileHeader - 2) + secondNavbar;
    }
    const navbarElem = document.querySelector('.js-actor-sticky-navigation');
    return navbarElem && navbarElem.getBoundingClientRect().y + navbarElem.getBoundingClientRect().height;
  }

  render() {
    const preview = this.state.actorData && this.state.actorData.previewPicture || this.props.actorData && this.props.actorData.previewPicture;
    const name    = this.state.actorData && this.state.actorData.previewPicture || this.props.actorData && this.props.actorData.previewPicture;

    if (!name || !preview) {
      return null;
    }

    return <Feed feedType={Flux.Constants.Feed.FeedType.PROFILE} isMobile={this.props.isMobile} sidebarContent={this.getSidebarContent} actorImageUrl={preview} actorName={name} actorId={this.props.actorId} getTopDistance={this.getTopDistance} />;
  }
}

ActorProfileFeed.propTypes = {
  actorData: PropTypes.object,
  actorId:   PropTypes.number,
  isMobile:  PropTypes.bool,
};

ActorProfileFeed.defaultProps = {
  isMobile: false,
};


export default ActorProfileFeed;
